module.exports = __webpack_public_path__ + "static/img/4.62a93e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/eng/4.png
// module id = l1XU
// module chunks = 0